export default __webpack_public_path__ + "static/media/4697@2x.a2455fe1.png";